import NavTile from './NavTile';

export default NavTile;
